import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsLogisticsLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLogistics" */ './SettingsLogisticsSuspense')
);

export const SettingsLogisticsAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsLogisticsLazy />
    </DelayedSuspense>
);
